import React, { useState } from 'react'

import { useTheme } from '@material-ui/styles'
import { Skeleton } from '@material-ui/lab'
import { Divider, ListItem, ListItemIcon, ListItemText, makeStyles } from '@material-ui/core'
import { ChevronRight, FiberManualRecord } from '@material-ui/icons'

import { StorePeriod } from './StorePeriod'

import useViewportSizes from '~/components/useViewportSize'
import { useLiterals } from '~/components/Literals'
import track from '~/track'

const useStyles = makeStyles((theme) => ({
  listItem: {
    paddingBlock: 16
  },
  listItemText: {
    [theme.breakpoints.up('md')]: {
      textDecoration: 'underline'
    },
    '& .MuiTypography-body2': {
      fontSize: 16
    }
  }
}))

function ListItemPeriod({ period, isLoadingGmb, store }) {
  const classes = useStyles()
  const theme = useTheme()
  const viewport = useViewportSizes()

  const [isOpenPeriod, setIsOpenPeriod] = useState(false)

  const { getLiteral } = useLiterals()

  const isMobile = viewport.width < theme.gofind.desktopMaxWidth

  const getPeriod = () => {
    const hourEnd = period?.endTime.includes(':00')
      ? period?.endTime.replace(':00', '')
      : period?.endTime

    const openOrClose = period?.isOpen ? `${getLiteral('2090')} - ` : `${getLiteral('2091')} - `
    const time = period?.isOpen ? `${getLiteral('2558', [hourEnd])}h` : getLiteral('2559')
    return `${openOrClose}${time}`
  }

  const handleOpenPeriod = () => {
    console.log('Period Dialog Open ')
    setIsOpenPeriod(true)
    track('cliqueHorarios', { category: 'loja', name: store?.name })
  }

  return (
    <>
      <StorePeriod
        store={store}
        weekdaysPeriod={period?.weekdays || []}
        isOpen={isOpenPeriod}
        setIsOpen={setIsOpenPeriod}
      />

      <Divider />
      {isLoadingGmb ? (
        <ListItem button className={classes.listItem}>
          <ListItemIcon>
            <Skeleton variant="circle" height={24} width={24} />
          </ListItemIcon>
          <ListItemText className={classes.listItemText} primary={<Skeleton variant="text" />} />
          {isMobile ? <ChevronRight style={{ color: '#698387' }} /> : null}
        </ListItem>
      ) : (
        <ListItem button onClick={handleOpenPeriod} className={classes.listItem}>
          <ListItemIcon>
            <FiberManualRecord style={{ color: period?.isOpen ? '#A6CD30' : '#f44336' }} />
          </ListItemIcon>
          <ListItemText className={classes.listItemText} primary={getPeriod()} />
          {isMobile ? <ChevronRight style={{ color: '#698387' }} /> : null}
        </ListItem>
      )}
    </>
  )
}

export default ListItemPeriod
